import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: boolean = true;

const tutorialSlice = createSlice({
  initialState,
  name: "tutorial",
  reducers: {
    setTutorial: (state: boolean, action: PayloadAction<boolean>) => {
      return action.payload;
    },
  },
});

export const { setTutorial } = tutorialSlice.actions;

export default tutorialSlice.reducer;
